import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import config from '~/config';

const AIFooter = withI18next()(({ t }) => (
  <div className="ai-footer">
    <img
      className="footer-background"
      src={`${config.staticPrefix}/static/assets/ai-genface/background_ai_genface.jpg`}
    />
    <div className="footer-content">
      <img
        className="footer-image"
        src={`${config.staticPrefix}/static/assets/ai-genface/banner_ai_genface.jpg`}
      />
      <div className="footer-description">
        <h3 className="ai-title">{t('what_is_ai_material')}</h3>
        <p className="ai-description">
          {t('ai_material_description_1')}
          <br />
          <br />
          {t('ai_material_description_2')}
          <br />
          <br />
          {t('ai_material_description_3')}
        </p>
      </div>
    </div>
    <style jsx>
      {`
        .ai-footer {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
          min-height: 300px;
          margin: 28px 0;
        }
        .ai-footer .footer-background {
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
          opacity: 0.5;
        }
        .ai-footer .footer-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 28px;
          width: 100%;
          z-index: 2;
        }
        .ai-footer .footer-image {
          width: 256px;
          height: 256px;
        }
        .ai-footer .footer-description {
          flex: 1;
          margin-left: 28px;
        }
        .ai-footer .ai-title {
          font-size: 20px;
          font-weight: bold;
        }
        .ai-footer .ai-description {
          margin-top: 14px;
        }
        @media (max-width: 600px) {
          .ai-footer .footer-content {
            flex-direction: column;
          }
        }
      `}
    </style>
  </div>
));

export default AIFooter;
